(function () {
  const toggleButton = document.querySelector('[data-noteworthy-content-expand]');
  const contentCards = document.querySelectorAll('[data-noteworthy-content]');

  if (!toggleButton || !contentCards) return;

  toggleButton.addEventListener('click', () => {
    Array.from(contentCards)
      .filter((card) => card.getAttribute('aria-hidden') === 'true')
      .slice(0, 3)
      .forEach((card) => {
        card.classList.remove('hidden');
        card.setAttribute('aria-hidden', 'false');
      });

    if (Array.from(contentCards).every((card) => card.getAttribute('aria-hidden') === 'false')) {
      toggleButton.classList.add('hidden');
    }
  });
})();
